import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false,
  name: 'mxFirstLetterOperation',
})
export class MxFirstLetterOperationPipe implements PipeTransform {
  constructor() {}
  transform(value: string, upperCase: boolean = true): string {
    return value
      ? upperCase
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : value.charAt(0).toLowerCase() + value.slice(1)
      : value;
  }
}
